import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../api/translate.service';

@Pipe({
  name: 'ivGetTranslationFn'
})
export class GetTranslationFnPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
  }
  transform(key: string, toUpperCase: boolean = false): string {
    return this.translateService.getTranslation(toUpperCase ? key.toUpperCase() : key);
  }
}
